//coded by Narain on (11/09/2024)

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchBotResponse } from '../utils/utils';

export const sendMessage = createAsyncThunk(
  'chat/sendMessage',
  async (input, { dispatch, getState }) => {

    const simulatedDelay = 2000;
    const botResponse = await new Promise((resolve) => {
      setTimeout(async () => {
        const response = await fetchBotResponse(input);
        resolve(response);
      }, simulatedDelay);
    });
    return botResponse;
  }
);

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    messages: [],
    input: '',
    isBotTyping: false,
  },
  reducers: {
    addUserMessage: (state, action) => {
      state.messages.push({ text: action.payload, sender: 'user' });
    },
    setInput: (state, action) => {
      state.input = action.payload;
    },
    resetInput: (state) => {
      state.input = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendMessage.pending, (state) => {
        state.isBotTyping = true;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.messages.push({ text: action.payload, sender: 'bot' });
        state.isBotTyping = false;
      })
      .addCase(sendMessage.rejected, (state) => {
        state.messages.push({
          text: 'An error occurred while fetching the response.',
          sender: 'bot',
        });
        state.isBotTyping = false;
      });
  },
});

export const { addUserMessage, setInput, resetInput } = chatSlice.actions;
export default chatSlice.reducer;
